import { render, staticRenderFns } from "./EqualOpportunities.vue?vue&type=template&id=53d735ef"
import script from "./EqualOpportunities.vue?vue&type=script&lang=js"
export * from "./EqualOpportunities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports